import { resource, RequestConfig } from '../helper/resource';

/**
 * [No Auth]经理信息&&简况
 */
export function queryFundManagerUsingPOST(
  req: InfoPersonDto | void,
  config?: RequestConfig
): Promise<ApiResultFundManagerInfoDto> {
  return resource.postNoAuth('/fundManager/queryFundManager', req, config);
}

/**
 * [No Auth]历任经理
 */
export function queryFundManagerAllUsingPOST(
  req: InfoCodeDto | void,
  config?: RequestConfig
): Promise<ApiResultListFundManagerInfoDto> {
  return resource.postNoAuth('/fundManager/queryFundManagerAll', req, config);
}

/**
 * [No Auth]在管&&历任基金
 */
export function queryFundManageredUsingPOST(
  req: InfoPersonDto | void,
  config?: RequestConfig
): Promise<ApiResultListLcFundManagerPositionInfo> {
  return resource.postNoAuth('/fundManager/queryFundManagered', req, config);
}
